import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#ffda44",
  d: "M345.043 15.922C317.309 5.633 287.314 0 256 0c-31.314-.001-61.31 5.633-89.043 15.922l-22.261 240.077 22.261 240.077C194.689 506.368 224.685 512 256 512c31.313 0 61.31-5.632 89.043-15.924L367.303 256z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#d80027",
  d: "M512 256c0-110.07-69.472-203.907-166.957-240.077v480.156C442.528 459.905 511.999 366.072 512 256"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0052b4",
  d: "M0 255.999c0 110.073 69.472 203.906 166.955 240.079l.001-480.154C69.472 52.094 0 145.928 0 255.999"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }